import { render, staticRenderFns } from "./VOrderListFilter.vue?vue&type=template&id=216bafbc"
import script from "./VOrderListFilter.vue?vue&type=script&lang=ts"
export * from "./VOrderListFilter.vue?vue&type=script&lang=ts"
import style0 from "./VOrderListFilter.vue?vue&type=style&index=0&id=216bafbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports